export default __webpack_public_path__ + "locales/pl/UploadPanel.json?hash=d350e5b7329118fbb89b705893a5ecb4";